import { OrganizationException } from '@/domain/organization/exception/OrganizationException'

export class CannotEditOrganizationException extends OrganizationException {
}
